var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"txt-c ds-search-blank"},[_vm._m(0),_c('p',{staticClass:"f14 c-gray"},[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"pb16"},[_c('img',{attrs:{"src":require("../../assets/images/common/blank.png")}})])
}]

export { render, staticRenderFns }